import {
  Input_Patientportal_PortalAccountSettingsMsg,
  PortalUserFragment,
  PortalUserFragmentDoc,
  useUpdatePortalUserSettingsMutation,
} from "../src/generated/graphql";
import { Maybe } from "graphql/jsutils/Maybe";
import { useCurrentUser } from "../helpers/utils";

export const useAccessibilitySettings = (): [
  Maybe<boolean>,
  (value: Maybe<boolean>) => void,
  { loading: boolean }
] => {
  const { currentUser, userLoading: portalUserSettingsLoading } =
    useCurrentUser();

  const portalUserSettings = currentUser?.settings;

  const accessibilityModeActive = portalUserSettings?.accessibilityModeActive;

  const [updatePortalUserSettingsMutation, { loading: updateLoading }] =
    useUpdatePortalUserSettingsMutation({
      update: (cache, { data }) => {
        if (currentUser) {
          const existingPortalUserFragment: Maybe<PortalUserFragment> =
            cache.readFragment({
              id: cache.identify(currentUser),
              fragmentName: "PortalUser",
              fragment: PortalUserFragmentDoc,
            });

          console.log("existingPortalUserFragment", existingPortalUserFragment);
          const updatedFragment = {
            ...existingPortalUserFragment,
            settings: data?.updatePortalUserSettings,
          };

          console.log("updatedFragment", updatedFragment);

          cache.writeFragment({
            id: cache.identify(currentUser),
            fragment: PortalUserFragmentDoc,
            fragmentName: "PortalUser",
            data: updatedFragment,
          });
        }
      },
    });

  const updatePortalUserSettings = (
    portalUserSettingsUpdate: Input_Patientportal_PortalAccountSettingsMsg
  ) => {
    updatePortalUserSettingsMutation({
      variables: {
        input: {
          patch: true,
          settings: portalUserSettingsUpdate,
        },
      },
    });
  };

  const loading = portalUserSettingsLoading || updateLoading;

  return [
    accessibilityModeActive,
    (value) => updatePortalUserSettings({ accessibilityModeActive: value }),
    { loading },
  ];
};
